<script>
import { onMount, onDestroy } from "svelte";
export let shouldUpdate
export let el1
export let el2
export let parent

let updater;
let mounted = false;
let startx = 0
let starty = 0
let endx = 0
let endy = 0
let updating;
let bezratio =2.5;
let bezratioB =1.5;
export let strokeWidth = 1;
export let strokeColor = "#000000";
export let pointRadius = 10;
export let pointColor = "#C00000";
	
$: (shouldUpdate) ? updating=requestAnimationFrame(step): cancelAnimationFrame(updating) ;

	onMount(()=>{
		window.addEventListener("resize",belayOn)
		mounted=true;
		console.log("Mounted a Belay Component");
		belayOn();		
	})
	
	onDestroy(()=>{
		window.removeEventListener("resize",belayOn)
		mounted=false;
		cancelAnimationFrame(updater)
		console.log("Destroyed a Belay Component");
	})
	
	function step(timestamp){
		if(shouldUpdate==true){		
			updater = requestAnimationFrame(step)
			belayOn();					
		}
	}
	
	function getRandomRotation(){
    return (Math.floor(Math.random() * 90)+45)
  }

  function getRandomSize(){
    return (Math.floor(Math.random() * 150)+50)
  }


	function belayOn(){		
		  var parentel = document.getElementById(parent)
			var r1 = document.getElementById(el1);
			var r2 = document.getElementById(el2);
			var r1rect = r1.getBoundingClientRect();
			var r2rect = r2.getBoundingClientRect();
			var parentrect = parentel.getBoundingClientRect();

			//calculate position based on the parent container
			startx = (r1rect.left-parentrect.left) + r1.offsetWidth;
	 		starty = (r1rect.top-parentrect.top) + r1.offsetHeight/2;
	 		endx = (r2rect.right-parentrect.left) - r2.offsetWidth;
	 		endy = (r2rect.top-parentrect.top) + r2.offsetHeight/2;
	}

	$:top = (starty>endy) ? endy : starty ;
	$:svgwidth = (endx>startx) ? (endx-startx) : (startx-endx) ;
	$:svgheight = (endy>starty)? (endy-starty)+strokeWidth : (starty-endy)+strokeWidth ;	
	
	$:p = (endy>starty) 
		? "M0,"+(strokeWidth/2)+" C"+(svgwidth/bezratio)+",0 "+(0+(svgwidth/bezratioB))+","+svgheight+" "+(svgwidth)+","+(svgheight-(strokeWidth/2))
		: "M0,"+(svgheight-(strokeWidth/2))+" C"+(0+svgwidth/bezratio)+","+(svgheight)+" "+(svgwidth/bezratioB)+",0 "+(svgwidth)+","+(strokeWidth/2);

</script>


<svg class="svg"  focusable="false" style="position:absolute;top:{top}px;left:{startx}px;width:{svgwidth}px;height:{svgheight}px;min-height:{strokeWidth}px;min-width:{strokeWidth};stroke-linecap:round;background:rgba(0,0,0,.0)" overflow="visible" >
  <g>
	  <path d={p} fill="none" stroke-linecap="round" stroke={strokeColor} stroke-width={strokeWidth}></path>
		{#if (endy>starty) }
		<circle cx={0} cy={0+strokeWidth/2} r={pointRadius} fill={pointColor} />
    <circle cx={svgwidth} cy={svgheight-(strokeWidth/2)} r={pointRadius} fill={pointColor} />
		{:else}
		<circle cx={0} cy={svgheight-strokeWidth/2} r={pointRadius} fill={pointColor} />
		<circle cx={svgwidth} cy={(strokeWidth/2)} r={pointRadius} fill={pointColor} />    
    {/if}
	</g>
</svg>



